<script>
  import { onMount } from 'svelte'
  import ViewContainer from '../../components/ViewContainer.svelte'
  import LocationAdd from './Location.add.svelte'
  import PageHeader from '../../components/PageHeader.svelte'
  import Button from '../../components/Button.svelte'
  import Spinner from '../../components/Spinner.svelte'
  import Modal from '../../components/Modal.svelte'
  import Icon from '../../components/Icon.svelte'
  import { locationStore, modalStore, clientStore, userStore, peopleStore } from '../../state/store'
  import { language, formatI18nDate, t } from '../../i18n/i18n'
  import { isUserAdmin, showInfo, getName, multiFilter } from '../../helpers/utils.js'
  import { push, location } from 'svelte-spa-router'
  import { getLocationData, getPeopleData, getClientData } from '../../state/actions'

  const adminKeys = ['assignee', 'client']
  const showAddLocation = () => modalStore.toggle('add_location')

  let promise
  onMount(() => {
    if(isUserAdmin($userStore)) {
      promise = Promise.all([getLocationData(), getClientData(), getPeopleData()])
    } else {
      promise = getLocationData()
    }
  })

  let searchTerm = ''
  $: locations = multiFilter($locationStore, ['name', 'address'], searchTerm)

</script>

<ViewContainer>
  <PageHeader>
    <h1>{$t.locations}</h1>
    {#if isUserAdmin($userStore)}
      <Button on:click={showAddLocation}>{$t['Add Location']}</Button>
    {/if}
  </PageHeader>
  {#await promise}
    <Spinner />
  {:then}
    <section class="g-search">
      <span class="icon"><Icon name='search' /></span>
      <input type="text" id="search" bind:value={searchTerm} placeholder={$t.search}>
    </section>
    <article class="g-card-list-wrapper">
      {#if $locationStore.length === 0}
        <div>
          {#if isUserAdmin($userStore)}
            <h2>{$t.no_locations_admin_header}</h2>
            <p>{$t.no_locations_admin_text}</p>
          {:else}
            <h2>{$t.no_locations_worker_header}</h2>
            <p>{$t.no_locations_worker_text}</p>
          {/if}
        </div>
      {:else }
        {#each locations as data, index}
          <ul on:click={() => push(`${$location}${data._id}`)} class='g-card-list'>
            {#each Object.entries(data) as [key, val]}
              {#if 
                key !== '_id' &&
                key !== '__v' &&
                key !== 'tenant' &&
                key !== 'client' &&
                key !== 'last_serviced' &&
                key !== 'assignee' &&
                key !== 'description' &&
                key !== 'coordinates' &&
                showInfo({key, isAdmin: isUserAdmin($userStore), adminKeys})
              }
                <li>
                  <p>{$t[key]}</p>
                  <p>{val}</p>
                </li>
              {/if}
              {#if isUserAdmin($userStore) && key === 'client'}
                <li>
                  <p>{$t[key]}</p>
                  <p>{getName($clientStore, val)}</p>
                </li>
              {/if}
              {#if key === 'last_serviced'}
                <li>
                  <p>{$t[key]}</p>
                  <p>{formatI18nDate($language, val)}</p>
                </li>
              {/if}
              {#if isUserAdmin($userStore) && key === 'assignee'}
                <li>
                  <p>{$t[key]}</p>
                  <p class:g-error={getName($peopleStore, val) === 'Unassigned'}>{getName($peopleStore, val)}</p>
                </li>
              {/if}
            {/each}
          </ul>
        {/each}
      {/if}
    </article>
  {/await}
  
  <Modal name='add_location'>
    <h1 slot='header'>{$t['Add Location']}</h1>
    <LocationAdd />
  </Modal>
</ViewContainer>
